import { stylers } from './stylers';

function renderMarker(map, position, data) {
    const icon = {
        url: stylers.icons.blue,
    };

    let marker;

    if (data) {
        const tmpl = markerTmpl(data);

        marker = new google.maps.Marker({
            position,
            map,
            icon,
            title: data.naam,
            content: tmpl,
            animation: google.maps.Animation.DROP,
        });
    } else {
        marker = new google.maps.Marker({
            position,
            map,
            icon,
            animation: google.maps.Animation.DROP,
        });
    }

    return marker;
}

function renderSimpleMarker(map, position) {
    const icon = {
        url: stylers.icons.red,
        scaledSize: new google.maps.Size(32, 49),
    };

    const marker = new google.maps.Marker({
        position,
        map,
        icon,
        animation: google.maps.Animation.DROP,
    });

    return marker;
}

function handleMarkerClick(map, marker, infowindow, cbOpen, cbClose) {
    google.maps.event.addListener(marker, 'click', () => {
        handleInfoWindow(marker, map, infowindow, 'open');

        if (cbOpen) {
            cbOpen();
        }
    });

    google.maps.event.addListener(map, 'click', () => {
        if (infowindow) {
            handleInfoWindow(marker, map, infowindow, 'close');
        }

        if (cbClose) {
            cbClose();
        }
    });
}

function handleInfoWindow(marker, map, infowindow, direction) {
    if (infowindow) {
        if (direction === 'open') {
            infowindow.setContent(marker.content);
            infowindow.open(map, marker);
        } else {
            infowindow.close(map, infowindow);
        }
    }
}

function markerTmpl(data) {
    const encodedAddress = encodeURIComponent(data.address);
    const url = `https://www.google.com/maps/place/${encodedAddress}+${data.city}/`;

    return `<article class="location__marker-box">
        <div class="location__marker-box__wrap">
            <div class="location__marker-box__grid">
                <div class="location__marker-box__main">
                    <h6 class="location__marker-box__title">${data.name}</h6>
                    <address class="location__marker-box__address">
                        <span class="location__marker-box__address">
                            ${data.address}, <br>${data.postalCode} ${data.city}
                        </span>
                    </address>
                    <p class="location__marker-box__tel location__marker-box__info">
                        <svg class="locations__item__contact__icon">
                            <use xlink:href="/frontend/icons/symbol-defs.svg#icon--phone"></use>
                        </svg>
                        <a href="tel:${data.phone}">
                            ${data.phone}
                        </a>
                    </p>
                    <p class="location__marker-box__mail location__marker-box__info">
                        <svg class="locations__item__contact__icon">
                            <use xlink:href="/frontend/icons/symbol-defs.svg#icon--mail"></use>
                        </svg>
                        <a href="mailto:${data.email}">
                            ${data.email}
                        </a>
                    </p>
                    <p class="location__marker-box__info">
                        <svg class="locations__item__contact__icon">
                            <use xlink:href="/frontend/icons/symbol-defs.svg#icon--location"></use>
                        </svg>
                        <a class="location__marker-box__link" href="${url}" target="_blank">
                            ${data.directionsTranslation}
                        </a>
                    </p>
                </div>
            </div>
        </div>
    </article>`;
}

export {
    renderMarker,
    renderSimpleMarker,
    handleMarkerClick,
    handleInfoWindow,
};
